import { InputAdornment } from '@mui/material';
import MuiTextField from '../TextField/TextField';
import style from './header.module.css';
import { CiSearch } from 'react-icons/ci';

interface HeaderType {
  title: string;
  showSearch?: boolean;
}

const Header = ({ title, showSearch }: HeaderType) => (
  <div className={style.container}>
    <div className={style.title}>{title}</div>
    {showSearch && (
      <div className={style.search}>
        <MuiTextField
          onChange={() => {}}
          placeholder="Search Here"
          className={style.searchInput}
          label={''}
          endAdornment={<CiSearch className={style.searchIcon} />}
        ></MuiTextField>
      </div>
    )}
  </div>
);

export default Header;
